<template>
		<div class="card">
			<div
				class="custom-control custom-radio"
				style="padding: 2rem; border: 1px solid rgba(0,0,0,.125);"
				v-for="(method, index) in payment"
				:key="index"
				:style="(method.gateway_id === 'internal-account' || method.gateway_id === 'internal-card')&&!getUserData.is_bank_customer?'display: none':''"
			>
				<input
					:id="method.gateway_id"
					name="paymentMethod"
					type="radio"
					class="custom-control-input"
					:value="method.gateway_id"
					v-model="paymentOption"
					@click="change(method.gateway_id)"
					data-test="paymentOptionMethodInput"
				>
				<label
					class="custom-control-label"
					:for="method.gateway_id"
					style="font-weight: 700;"
					id="credit-debit-head"
					data-test="paymentOptionGatewayName"
				>
					{{method.gateway_name}}
				</label>
				<order-otp-verification
					@otpVerified="orderProduct()"
					v-if="(paymentOption === method.gateway_id
                                      && (paymentOption === 'cod'
                                      || paymentOption === 'payment_paylater'))"
				>
				</order-otp-verification>
				<!--<payment-gateway v-if="paymentOption === method.gateway_id-->
				<!--&& paymentOption === 'payment_paylater'"-->
				<!--&gt;-->
				<!--</payment-gateway>-->
				<stripe-payment-gateway v-if="paymentOption === method.gateway_id
                                      && paymentOption === 'payment_stripe'">
				</stripe-payment-gateway>
				<!--<payment-gateway-razor-pay v-if="paymentOption === method.gateway_id-->
				<!--&& paymentOption === 'razorPay'">-->
				<!--</payment-gateway-razor-pay>-->
				<razor-pay-web-integration v-if="paymentOption === method.gateway_id
                                      && paymentOption === 'razorpay'">
				</razor-pay-web-integration>
				<bank-internal-account v-if="paymentOption === method.gateway_id
                                      && paymentOption === 'internal-account' && getUserData.is_bank_customer">
				</bank-internal-account>
				<bank-internal-card v-if="paymentOption === method.gateway_id
                                      && paymentOption === 'internal-card' && getUserData.is_bank_customer">
				</bank-internal-card>
			</div>
		</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import OrderOtpVerification from './OrderOtpVerification'
import StripePaymentGateway from '../../paymentGateway/stripe/StripePaymentGateway'
import RazorPayWebIntegration from '../../paymentGateway/razorPay/RazorPayWebIntegration'
import BankInternalAccount from '../../paymentGateway/bankGateway/BankInternalAccount'
import BankInternalCard from '../../paymentGateway/bankGateway/BankInternalCard'
import { orderApi } from '../../../../services/ApiServices/orderApi'

export default {
	components: {
		BankInternalAccount,
		BankInternalCard,
		RazorPayWebIntegration,
		StripePaymentGateway,
		OrderOtpVerification
	},
	computed: {
		...mapGetters('siteData', ['getPaymentGatewayId']),
		...mapGetters('user', ['getUserData'])
	},
	data () {
		return {
			paymentOption: '',
			payment: [],
			total: 0,
			discount: 0,
			coinDiscount: 0,
			coinValue: 0,
			coinNo: 0
		}
	},
	methods: {
		...mapActions('siteData', ['setPaymentGatewayIdData']),
		...mapActions('buynow', ['updateGiftCardQuantity', 'updateCoinAmount']),
		...mapActions('cart', [
			'updateGiftCardCartQuantity',
			'updateCartCoinAmount'
		]),
		change (paymentGatewayId) {
			this.setPaymentGatewayIdData(paymentGatewayId)
		},
		orderProduct () {
			if (this.paymentOption) {
				let payMode = ''
				if (this.getPaymentGatewayId === 'cod') {
					payMode = 'COD'
				}
				if (this.getPaymentGatewayId === 'payment_paylater') {
					payMode = 'PAY_LATER'
				}
				orderApi.orderCharge(payMode)
					.then(() => {
						this.$router.push('/order-success')
					})
					.catch(() => {
						this.$forceUpdate()
					})
			}
		}
	},
	mounted () {
		orderApi.getAllPaymentOptions()
			.then((res) => {
				this.payment = res.data
				if (res.data.length > 0) {
					this.paymentOption = this.payment[0].gateway_id
					this.setPaymentGatewayIdData(this.paymentOption)
				}
			})
	},
	name: 'payment-gateway-selector'
}
</script>

<style scoped>

</style>
